<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-titlepage title-page" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">Trip Wire</h1>
<h2 class="title-page-subtitle">A Renegade Justice Thriller featuring Morgan Ames</h2>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">CJ Lyons</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-square">
<div class="title-page-publisher-logo-size-container publisher-logo-width-500">
<img alt="Edgy Reads" class="title-page-publisher-logo-image" src="images/edgyreadslogo_edited-1.jpg"/>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?43d93cc0